import { ButtonProps, PolymorphicComponentProps } from "@mantine/core"
import { DefaultButton } from "../Buttons"
import { useTranslation } from "react-i18next"
import { IconPlus } from "@tabler/icons-react"

export function FieldFilterButton(
  props: Omit<
    PolymorphicComponentProps<"button", ButtonProps>,
    "children" | "rightSection" | "variant"
  >
) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultButton rightSection={<IconPlus size={20} stroke={1} />} {...props}>
      {t("FieldFilter")}
    </DefaultButton>
  )
}
